import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-784ce501")

_pushScopeId("data-v-784ce501")
const _hoisted_1 = { class: "p-grid p-m-0 p-fluid kn-page-content" }
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = {
  ref: "menu-configuration-form",
  class: "p-p-3"
}
const _hoisted_4 = { class: "p-field p-mb-5" }
const _hoisted_5 = { class: "p-inputgroup" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = { for: "name" }
const _hoisted_8 = { class: "p-field p-mb-5" }
const _hoisted_9 = { class: "p-inputgroup" }
const _hoisted_10 = { class: "p-float-label" }
const _hoisted_11 = { for: "descr" }
const _hoisted_12 = { id: "descr-help" }
const _hoisted_13 = { class: "p-field p-mb-5" }
const _hoisted_14 = { class: "p-inputgroup" }
const _hoisted_15 = { class: "p-float-label" }
const _hoisted_16 = { for: "menuNodeContent" }
const _hoisted_17 = { class: "p-field" }
const _hoisted_18 = { class: "p-inputgroup" }
const _hoisted_19 = { class: "p-float-label" }
const _hoisted_20 = { for: "staticPage" }
const _hoisted_21 = { class: "p-inputgroup" }
const _hoisted_22 = { class: "p-float-label" }
const _hoisted_23 = { for: "externalApplicationUrl" }
const _hoisted_24 = { class: "p-field p-mb-5" }
const _hoisted_25 = { class: "p-inputgroup" }
const _hoisted_26 = { class: "p-float-label" }
const _hoisted_27 = { for: "objId" }
const _hoisted_28 = { class: "p-field p-mb-5" }
const _hoisted_29 = { class: "p-inputgroup" }
const _hoisted_30 = { class: "p-float-label" }
const _hoisted_31 = { for: "objParameters" }
const _hoisted_32 = { class: "p-inputgroup" }
const _hoisted_33 = { class: "p-float-label" }
const _hoisted_34 = { for: "functionality" }
const _hoisted_35 = { class: "p-inputgroup" }
const _hoisted_36 = { class: "p-float-label" }
const _hoisted_37 = { for: "initialPath" }
const _hoisted_38 = { class: "p-col-12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_FontAwesomePicker = _resolveComponent("FontAwesomePicker")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_RelatedDocumentList = _resolveComponent("RelatedDocumentList")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_DocumentBrowserTree = _resolveComponent("DocumentBrowserTree")
  const _component_Card = _resolveComponent("Card")
  const _component_RolesCard = _resolveComponent("RolesCard")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
      start: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.menuNode.name), 1)
      ]),
      end: _withId(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.save,
          disabled: _ctx.formValid
        }, null, 8, ["onClick", "disabled"]),
        _createVNode(_component_Button, {
          class: "p-button-text p-button-rounded p-button-plain",
          icon: "pi pi-times",
          onClick: _ctx.closeForm
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar",
          "data-test": "progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Card, null, {
          content: _withId(() => [
            _createVNode("form", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("span", _hoisted_6, [
                    _createVNode(_component_InputText, {
                      id: "name",
                      type: "text",
                      modelValue: _ctx.v$.menuNode.name.$model,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.menuNode.name.$model = $event)),
                      modelModifiers: { trim: true },
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDataChange(_ctx.v$.menuNode.name))),
                      class: "p-inputtext p-component kn-material-input"
                    }, null, 8, ["modelValue"]),
                    _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.menuManagement.form.name')) + " *", 1)
                  ])
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.menuNode.name,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.menuManagement.form.name') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("span", _hoisted_10, [
                    _createVNode(_component_InputText, {
                      id: "descr",
                      type: "text",
                      modelValue: _ctx.v$.menuNode.descr.$model,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.menuNode.descr.$model = $event)),
                      modelModifiers: { trim: true },
                      onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onDataChange(_ctx.v$.menuNode.descr))),
                      class: "p-inputtext p-component kn-material-input",
                      "aria-describedby": "descr-help"
                    }, null, 8, ["modelValue"]),
                    (_ctx.isIconSelectorShown(_ctx.menuNode) && (_ctx.menuNode.icon != null || _ctx.menuNode.custIcon != null))
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          icon: "pi pi-times",
                          onClick: _ctx.clearSelectedIcon
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.isCustomIconShown(_ctx.menuNode))
                      ? (_openBlock(), _createBlock(_component_Button, { key: 1 }, {
                          default: _withId(() => [
                            _createVNode("img", {
                              style: {"max-height":"26px","max-width":"26px"},
                              src: _ctx.selectedIcon
                            }, null, 8, ["src"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isFaIconShown(_ctx.menuNode))
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 2,
                          style: {"display":"inline-flex","justify-content":"center"}
                        }, {
                          default: _withId(() => [
                            _createVNode("i", { class: _ctx.selectedIcon }, null, 2)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isIconSelectorShown(_ctx.menuNode))
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 3,
                          class: "p-button",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openFontAwesomeSelectionModal()))
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('managers.menuManagement.chooseIcon').toUpperCase()), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('managers.menuManagement.description')) + " *", 1)
                  ])
                ]),
                _createVNode("small", _hoisted_12, _toDisplayString(_ctx.$t('managers.menuManagement.descrHelp')), 1),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.menuNode.descr,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.menuManagement.description') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode(_component_FontAwesomePicker, {
                showModal: _ctx.chooseIconModalShown,
                onChooseIcon: _ctx.onChoosenIcon,
                onCloseFontAwesomeModal: _ctx.closeFontAwesomeSelectionModal
              }, null, 8, ["showModal", "onChooseIcon", "onCloseFontAwesomeModal"]),
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("span", _hoisted_15, [
                    _createVNode(_component_Dropdown, {
                      id: "menuNodeContent",
                      modelValue: _ctx.v$.menuNode.menuNodeContent.$model,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.menuNode.menuNodeContent.$model = $event)),
                      options: _ctx.menuNodeContent,
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onMenuNodeChange(_ctx.v$.menuNode.menuNodeContent))),
                      optionLabel: "name",
                      optionValue: "value",
                      class: "p-dropdown p-component p-inputwrapper p-inputwrapper-filled kn-material-input"
                    }, null, 8, ["modelValue", "options"]),
                    _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('managers.menuManagement.form.menuNodeContent')) + " *", 1)
                  ])
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.menuNode.menuNodeContent,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.menuManagement.form.menuNodeContent') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", {
                class: "p-field p-mb-5",
                hidden: _ctx.staticPageHidden
              }, [
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    _createVNode("span", _hoisted_19, [
                      _createVNode(_component_Dropdown, {
                        id: "staticPage",
                        modelValue: _ctx.v$.menuNode.staticPage.$model,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.menuNode.staticPage.$model = $event)),
                        options: _ctx.staticPagesList,
                        onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onStaticPageSelect(_ctx.v$.menuNode.staticPage))),
                        optionLabel: "name",
                        optionValue: "name",
                        class: "p-dropdown p-component p-inputwrapper p-inputwrapper-filled kn-material-input"
                      }, null, 8, ["modelValue", "options"]),
                      _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('managers.menuManagement.form.staticPage')) + " *", 1)
                    ])
                  ]),
                  _createVNode(_component_KnValidationMessages, {
                    vComp: _ctx.v$.menuNode.staticPage,
                    additionalTranslateParams: { fieldName: _ctx.$t('managers.menuManagement.form.staticPage') }
                  }, null, 8, ["vComp", "additionalTranslateParams"])
                ])
              ], 8, ["hidden"]),
              _createVNode("div", {
                class: "p-field p-mb-5",
                hidden: _ctx.externalAppHidden
              }, [
                _createVNode("div", _hoisted_21, [
                  _createVNode("span", _hoisted_22, [
                    _createVNode(_component_InputText, {
                      id: "externalApplicationUrl",
                      type: "text",
                      modelValue: _ctx.v$.menuNode.externalApplicationUrl.$model,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.menuNode.externalApplicationUrl.$model = $event)),
                      modelModifiers: { trim: true },
                      onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onDataChange(_ctx.v$.menuNode.externalApplicationUrl))),
                      class: "p-inputtext p-component kn-material-input"
                    }, null, 8, ["modelValue"]),
                    _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('managers.menuManagement.form.externalApplicationUrl')) + " *", 1)
                  ])
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.menuNode.externalApplicationUrl,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.menuManagement.form.externalApplicationUrl') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ], 8, ["hidden"]),
              _createVNode("div", { hidden: _ctx.documentHidden }, [
                _createVNode("div", _hoisted_24, [
                  _createVNode("div", _hoisted_25, [
                    _createVNode("span", _hoisted_26, [
                      _createVNode(_component_InputText, {
                        id: "selectedDocument",
                        type: "text",
                        modelValue: _ctx.v$.menuNode.document.$model,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.v$.menuNode.document.$model = $event)),
                        modelModifiers: { trim: true },
                        onBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onDataChange(_ctx.v$.menuNode.document))),
                        class: "p-inputtext p-component kn-material-input"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_InputText, {
                        hidden: true,
                        id: "objId",
                        type: "text",
                        modelValue: _ctx.v$.menuNode.objId.$model,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.v$.menuNode.objId.$model = $event)),
                        modelModifiers: { trim: true },
                        onBlur: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onDataChange(_ctx.v$.menuNode.objId))),
                        class: "p-inputtext p-component kn-material-input"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_Button, {
                        icon: "pi pi-search",
                        class: "p-button",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.openRelatedDocumentModal()))
                      }),
                      _createVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('managers.menuManagement.form.document')) + " *", 1)
                    ])
                  ]),
                  _createVNode(_component_KnValidationMessages, {
                    vComp: _ctx.v$.menuNode.document,
                    additionalTranslateParams: { fieldName: _ctx.$t('managers.menuManagement.form.document') }
                  }, null, 8, ["vComp", "additionalTranslateParams"])
                ]),
                _createVNode("div", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    _createVNode("span", _hoisted_30, [
                      _createVNode(_component_InputText, {
                        id: "objParameters",
                        type: "text",
                        modelValue: _ctx.v$.menuNode.objParameters.$model,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.v$.menuNode.objParameters.$model = $event)),
                        modelModifiers: { trim: true },
                        onBlur: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onDataChange(_ctx.v$.menuNode.objParameters))),
                        class: "p-inputtext p-component kn-material-input"
                      }, null, 8, ["modelValue"]),
                      _createVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('managers.menuManagement.form.objParameters')), 1)
                    ])
                  ]),
                  _createVNode(_component_KnValidationMessages, {
                    vComp: _ctx.v$.menuNode.objParameters,
                    additionalTranslateParams: { fieldName: _ctx.$t('managers.menuManagement.form.objParameters') }
                  }, null, 8, ["vComp", "additionalTranslateParams"])
                ]),
                _createVNode(_component_Dialog, {
                  header: _ctx.$t('managers.menuManagement.selectDocument'),
                  visible: _ctx.displayModal,
                  "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => (_ctx.displayModal = $event)),
                  style: { width: '50vw' },
                  modal: true
                }, {
                  default: _withId(() => [
                    _createVNode(_component_RelatedDocumentList, {
                      loading: _ctx.loading,
                      onSelectedDocument: _ctx.onDocumentSelect,
                      "data-test": "related-documents-list"
                    }, null, 8, ["loading", "onSelectedDocument"])
                  ]),
                  _: 1
                }, 8, ["header", "visible"])
              ], 8, ["hidden"]),
              _createVNode("div", {
                class: "p-field p-mb-5",
                hidden: _ctx.functionalityHidden
              }, [
                _createVNode("div", _hoisted_32, [
                  _createVNode("span", _hoisted_33, [
                    _createVNode(_component_Dropdown, {
                      id: "functionality",
                      modelValue: _ctx.v$.menuNode.functionality.$model,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.v$.menuNode.functionality.$model = $event)),
                      options: _ctx.menuNodeContentFunctionalies,
                      onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onFunctionalityTypeChange(_ctx.v$.menuNode.functionality))),
                      optionLabel: "name",
                      optionValue: "value",
                      class: "p-dropdown p-component p-inputwrapper p-inputwrapper-filled kn-material-input"
                    }, null, 8, ["modelValue", "options"]),
                    _createVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('managers.menuManagement.form.functionality')) + "*", 1)
                  ])
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.menuNode.functionality,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.menuManagement.form.functionality') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ], 8, ["hidden"]),
              _createVNode("div", {
                class: "p-field p-mb-5",
                hidden: _ctx.workspaceInitialHidden
              }, [
                _createVNode("div", _hoisted_35, [
                  _createVNode("span", _hoisted_36, [
                    _createVNode(_component_Dropdown, {
                      id: "initialPath",
                      modelValue: _ctx.v$.menuNode.initialPath.$model,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.v$.menuNode.initialPath.$model = $event)),
                      options: _ctx.workspaceOptions,
                      optionLabel: "name",
                      optionValue: "value",
                      class: "p-dropdown p-component p-inputwrapper p-inputwrapper-filled kn-material-input"
                    }, null, 8, ["modelValue", "options"]),
                    _createVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('managers.menuManagement.form.initialPath')) + " *", 1)
                  ])
                ])
              ], 8, ["hidden"]),
              _createVNode("div", {
                class: "p-field p-mb-5",
                hidden: _ctx.documentTreeHidden
              }, [
                _createVNode("p", null, "Open document browser on " + _toDisplayString(_ctx.v$.menuNode.initialPath.$model), 1),
                _createVNode(_component_DocumentBrowserTree, {
                  selected: _ctx.v$.menuNode.initialPath.$model,
                  onSelectedDocumentNode: _ctx.onSelectedDocumentNode,
                  loading: _ctx.loading
                }, null, 8, ["selected", "onSelectedDocumentNode", "loading"])
              ], 8, ["hidden"])
            ], 512)
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_38, [
        _createVNode(_component_RolesCard, {
          hidden: _ctx.hideForm,
          rolesList: _ctx.roles,
          parentNodeRoles: _ctx.parentNodeRoles,
          selected: _ctx.selectedMenuNode.roles,
          onChanged: _cache[23] || (_cache[23] = ($event: any) => (_ctx.setSelectedRoles($event)))
        }, null, 8, ["hidden", "rolesList", "parentNodeRoles", "selected"])
      ])
    ])
  ], 64))
})